import React, { memo, useContext } from "react";
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { SarasDnDListContext } from './SarasDnDList';
import { buildSarasDnDId, useSarasDnDDragState } from './SarasDnDProvider';

const SarasDnDCard = memo(({ index, rowKey, children, isSortMode, cardStyle }) => {
    const { dndType, groupKey } = useContext(SarasDnDListContext);
    const { activeId, destinationGroupKey, destinationIndex, overId } = useSarasDnDDragState();
    const draggableId = buildSarasDnDId(groupKey, rowKey);
    const dragEnabled = isSortMode === undefined ? true : isSortMode;
    const {
        attributes,
        isDragging,
        listeners,
        setNodeRef,
        transform,
        transition,
    } = useSortable({
        id: draggableId,
        disabled: !dragEnabled,
        data: {
            cardStyle,
            children,
            dndType,
            groupKey,
            index,
            rowKey: String(rowKey),
        },
    });
    const showTopMarker = activeId
        && activeId !== draggableId
        && destinationGroupKey === groupKey
        && destinationIndex === index;
    const showBottomMarker = activeId
        && activeId !== draggableId
        && destinationGroupKey === groupKey
        && destinationIndex === index + 1
        && overId === draggableId;

    return (
        <div
            ref={setNodeRef}
            {...attributes}
            {...listeners}
            style={{
                position: 'relative',
                ...cardStyle,
                opacity: isDragging ? 0.35 : undefined,
                transform: CSS.Transform.toString(transform),
                transition,
            }}
        >
            {showTopMarker ? (
                <div
                    aria-hidden="true"
                    style={{
                        position: 'absolute',
                        top: '-8px',
                        left: '8px',
                        right: '8px',
                        height: '3px',
                        borderRadius: '999px',
                        background: '#1f6feb',
                        boxShadow: '0 0 0 3px rgba(31, 111, 235, 0.14)',
                        zIndex: 2,
                    }}
                />
            ) : null}
            {children}
            {showBottomMarker ? (
                <div
                    aria-hidden="true"
                    style={{
                        position: 'absolute',
                        bottom: '-8px',
                        left: '8px',
                        right: '8px',
                        height: '3px',
                        borderRadius: '999px',
                        background: '#1f6feb',
                        boxShadow: '0 0 0 3px rgba(31, 111, 235, 0.14)',
                        zIndex: 2,
                    }}
                />
            ) : null}
        </div>
    );
});

export default SarasDnDCard;
